@if (!isMobile()) {
  <header class="header">
    <div class="container">
      <div class="content">
        <div class="content__left">
          <app-burger-menu></app-burger-menu>
          <a *appShellNoSSR [href]="seo.originalLocationUrl + '/' + lang.current" [routerLink]="['/', lang.current]">
            <img class="content__left--logo" [src]="'/assets/img/logo' + '.svg'" alt="logo">
          </a>
          <div class="content__left--links">
            <a [routerLink]="['/', lang.current, 'bonuses']" routerLinkActive="active"
               class="content__left--links-item">
              {{ 'link.bonus' | translate }}
            </a>
            <a [routerLink]="['/', lang.current, 'tournaments']" routerLinkActive="active"
               class="content__left--links-item">
              {{ 'link.tournaments' | translate }}
            </a>
            <a [routerLink]="['/', lang.current, 'games']" routerLinkActive="active" class="content__left--links-item">
              {{ 'btn.play' | translate }}
            </a>
          </div>
        </div>
        <div class="content__right">
          <div (click)="onClickSearch()" class="search">
            <i [ngClass]="{'active': gamesFilters.state().isShowSearchBar}" class="icon-search"></i>
            <span class="search__label">{{ 't.search' | translate }}</span>
          </div>
          @if (!user.auth) {
            <button [routerLink]="['/', lang.current, 'login']" class="btn small"
                    [ngClass]="{'glowing-btn': user.isUserAlreadyRegistered}"
            >{{ 'btn.signin' | translate }}
            </button>
            <button [routerLink]="['/', lang.current, 'register']" class="btn small"
                    [ngClass]="{'glowing-btn': !user.isUserAlreadyRegistered}"
            >{{ 'btn.singup' | translate }}
            </button>
          } @else {
            <app-header-balance></app-header-balance>
            <i class="icon-user" [routerLink]="['/', lang.current, 'account']"></i>
            <div class="content__right--name" [routerLink]="['/', lang.current, 'account']">{{ user?.info?.nickname }}
            </div>
          }
          <ng-template #auth>
            <app-header-balance></app-header-balance>
            <i class="icon-user" [routerLink]="['/', lang.current, 'account']"></i>
            <div class="content__right--name" [routerLink]="['/', lang.current, 'account']">{{ user?.info?.nickname }}
            </div>
          </ng-template>
          <app-notification-sidebar *appShellNoSSR></app-notification-sidebar>
        </div>
      </div>
    </div>
  </header>
}
